import PageMetaData from '@v4/utils/data/PageMetaData'
import { useMemo } from 'react'
import useStyles from './Content.styled'

export const useContent = props => {
	const {
		mobileImage,
		desktopImage,
		contentWidth,
		textShadow,
		extraShortcuts,
		mobileImagePosition,

		text,
		textKey,
		textConfig,
		textEditable,

		buttonText,
		buttonAction,
		buttonTextEditable,
		buttonTextConfig,
		buttonTextKey,

		onTextClick,
		onButtonClick,
		onImageClick,
		onMobileImageClick,
		onTextChange,
		onButtonTextChange,
		buttonLink = null,
		onClick,
	} = props

	const isBackground = mobileImagePosition === PageMetaData.IMAGE_POSITION.BACKGROUND

	const { classes, cx } = useStyles({ ...props, isBackground }, { props })

	const isMobileImageExist = !!mobileImage?.image || !!desktopImage?.image
	const withBgMobileImage = isMobileImageExist && isBackground

	const sxWhite = useMemo(
		() => ({
			white: {
				md: withBgMobileImage,
			},
		}),
		[withBgMobileImage],
	)

	const sx = useMemo(
		() => ({
			white: {
				md: withBgMobileImage,
			},
			shadow: {
				md: withBgMobileImage,
			},
		}),
		[withBgMobileImage],
	)

	return [
		{
			classes,
			cx,
			mobileImage,
			desktopImage,
			contentWidth,
			textShadow,
			extraShortcuts,
			withMobileImage: isMobileImageExist && !isBackground,
			withBgDesktopImage: !!desktopImage?.image,
			withBgMobileImage,
			sx,
			sxWhite,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonAction,
			buttonLink,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,
		},
		{
			handleTextClick: onTextClick,
			handleButtonClick: onButtonClick,
			handleMobileImageClick: onMobileImageClick,
			handleDesktopImageClick: onImageClick,
			handleTextChange: onTextChange,
			handleButtonTextChange: onButtonTextChange,
			handleClick: onClick,
		},
	]
}
